/**
 * Cart drawer: Subi-style one-time vs Subscribe when exactly 1 jar of pudding.
 */
(function () {
  if (window.__cartPuddingPurchaseTypeInit) return;
  window.__cartPuddingPurchaseTypeInit = true;

  var processing = false;
  var syncTimer = null;

  function getConfig() {
    var el = document.getElementById('cart-pudding-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function getSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean)
      .join(',');
  }

  function refreshCart(sections, itemCount) {
    document.querySelectorAll('[data-cart-pudding-purchase-type]').forEach(function (root) {
      root.classList.remove('is-busy');
    });

    if (sections && window.Shopify && typeof window.Shopify.updateCartSections === 'function') {
      window.Shopify.updateCartSections(sections);
    }

    try {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: itemCount,
              source: 'cart-pudding-purchase-type',
              sections: sections || {},
            },
          },
        })
      );
    } catch (e) {
      console.error('[cart-pudding-purchase-type]', e);
    }
    processing = false;
  }

  function setBusy(root, busy) {
    if (!root) return;
    root.classList.toggle('is-busy', busy);
  }

  function isPuddingItem(item, config) {
    if (!item || !config) return false;
    if (config.productId && item.product_id === config.productId) return true;
    if (config.productHandle && item.handle === config.productHandle) return true;
    return false;
  }

  function buildMarkup(line, quantity, isSubscribed, config) {
    var oneTime = formatMoney(config.oneTimeCents);
    var subPrice = formatMoney(config.subscribeCents);
    var planId = config.sellingPlanId;

    return (
      '<div class="cart-pudding-purchase-type" data-cart-pudding-purchase-type data-line="' +
      line +
      '" data-quantity="' +
      quantity +
      '" data-selling-plan-id="' +
      planId +
      '">' +
      '<p class="cart-pudding-purchase-type__heading">Purchase options</p>' +
      '<div class="cart-pudding-purchase-type__options" role="radiogroup" aria-label="Purchase options">' +
      '<button type="button" class="cart-pudding-purchase-type__card' +
      (isSubscribed ? '' : ' is-selected') +
      '" role="radio" aria-checked="' +
      (isSubscribed ? 'false' : 'true') +
      '" data-purchase-type="one-time">' +
      '<span class="cart-pudding-purchase-type__radio" aria-hidden="true"></span>' +
      '<span class="cart-pudding-purchase-type__content"><span class="cart-pudding-purchase-type__title">One-time purchase</span></span>' +
      '<span class="cart-pudding-purchase-type__price">' +
      oneTime +
      '</span></button>' +
      '<button type="button" class="cart-pudding-purchase-type__card' +
      (isSubscribed ? ' is-selected' : '') +
      '" role="radio" aria-checked="' +
      (isSubscribed ? 'true' : 'false') +
      '" data-purchase-type="subscribe" data-selling-plan="' +
      planId +
      '">' +
      '<span class="cart-pudding-purchase-type__radio" aria-hidden="true"></span>' +
      '<span class="cart-pudding-purchase-type__content">' +
      '<span class="cart-pudding-purchase-type__title">Subscribe &amp; Save 12%</span>' +
      '<span class="cart-pudding-purchase-type__meta">Delivered monthly · Cancel anytime</span></span>' +
      '<span class="cart-pudding-purchase-type__price">' +
      subPrice +
      '</span></button></div></div>'
    );
  }

  function ensureConfig(callback) {
    var config = getConfig() || {
      productHandle: 'simply-hair-pudding',
      productId: 0,
      sellingPlanId: 0,
      oneTimeCents: 3400,
      subscribeCents: 2992,
    };

    if (config.sellingPlanId) {
      callback(config);
      return;
    }

    fetch('/products/simply-hair-pudding.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var variant = product.variants && product.variants[0];
        var allocation =
          variant &&
          variant.selling_plan_allocations &&
          variant.selling_plan_allocations[0];

        if (variant) {
          config.productId = product.id;
          config.oneTimeCents = variant.price;
        }
        if (allocation) {
          config.sellingPlanId = allocation.selling_plan_id;
          config.subscribeCents = allocation.price;
        }
        callback(config);
      })
      .catch(function () {
        callback(config);
      });
  }

  function syncPurchaseType() {
    var container = document.querySelector('[data-cart-drawer-purchase-type]');
    if (!container) return;

    ensureConfig(function (config) {
      if (!config.sellingPlanId) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var puddingQty = 0;
        var line = 0;
        var quantity = 1;
        var isSubscribed = false;

        cart.items.forEach(function (item, index) {
          if (!isPuddingItem(item, config)) return;
          puddingQty += item.quantity;
          if (!line) {
            line = index + 1;
            quantity = item.quantity;
            isSubscribed = Boolean(item.selling_plan_allocation);
            if (item.selling_plan_allocation && item.selling_plan_allocation.price) {
              config.subscribeCents = item.selling_plan_allocation.price;
            }
            if (item.original_price) {
              config.oneTimeCents = item.original_price;
            }
          }
        });

        if (puddingQty !== 1 || !line) {
          container.hidden = true;
          container.innerHTML = '';
          return;
        }

        container.hidden = false;
        var existing = container.querySelector('[data-cart-pudding-purchase-type]');
        var needsRebuild =
          !existing ||
          Number(existing.dataset.line) !== line ||
          Number(existing.dataset.quantity) !== quantity;

        if (needsRebuild) {
          container.innerHTML = buildMarkup(line, quantity, isSubscribed, config);
          return;
        }

        existing.querySelectorAll('[data-purchase-type]').forEach(function (button) {
          var selected =
            (button.getAttribute('data-purchase-type') === 'subscribe' && isSubscribed) ||
            (button.getAttribute('data-purchase-type') === 'one-time' && !isSubscribed);
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      })
      .catch(function (e) {
        console.error('[cart-pudding-purchase-type]', e);
      });
    });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncPurchaseType, 50);
  }

  function changePurchaseType(root, sellingPlanId) {
    if (processing) return;

    var line = Number(root.dataset.line);
    var quantity = Number(root.dataset.quantity) || 1;
    if (!line) return;

    processing = true;
    setBusy(root, true);

    var sections = getSectionIds();
    var payload = {
      line: line,
      quantity: quantity,
      selling_plan: sellingPlanId || '',
      sections: sections,
      sections_url: window.location.pathname,
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status && data.message) {
          console.error('[cart-pudding-purchase-type]', data.message);
          processing = false;
          setBusy(root, false);
          return;
        }
        refreshCart(data.sections, data.item_count);
        scheduleSync();
      })
      .catch(function (e) {
        console.error('[cart-pudding-purchase-type]', e);
        processing = false;
        setBusy(root, false);
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[data-purchase-type]');
    if (!button) return;

    var root = button.closest('[data-cart-pudding-purchase-type]');
    if (!root) return;

    event.preventDefault();

    if (button.classList.contains('is-selected')) return;

    var type = button.getAttribute('data-purchase-type');
    var sellingPlanId =
      type === 'subscribe' ? button.getAttribute('data-selling-plan') || root.dataset.sellingPlanId : null;

    changePurchaseType(root, sellingPlanId);
  });

  document.addEventListener('cart:update', function (event) {
    var source = event && event.detail && event.detail.data && event.detail.data.source;
    if (source === 'cart-pudding-purchase-type') return;
    scheduleSync();
  });

  document.addEventListener('cart:sections-updated', scheduleSync);
  scheduleSync();
})();
